// src/theme/tokens/typography.js
// Source of truth for Figma typography sizing (fontSize + lineHeight) tokens

export const typography = {
  // Headings
  fontSizeHeading1: 24,   // h1-size (24/34 Bold)
  lineHeightHeading1: 34, // h1-line-height

  fontSizeHeading2: 20,   // h2-size (20/28 Semi Bold)
  lineHeightHeading2: 28, // h2-line-height

  fontSizeHeading3: 16,   // h3-size (16/22 Bold)
  lineHeightHeading3: 22, // h3-line-height

  fontSizeHeading4: 14,   // h4-size (14/20 Semi Bold)
  lineHeightHeading4: 20, // h4-line-height

  fontSizeHeading5: 12,   // h5-size (12/16 Bold)
  lineHeightHeading5: 16, // h5-line-height

  fontSizeHeading6: 10,   // h6-size (10/14 Semi Bold)
  lineHeightHeading6: 14, // h6-line-height

  fontSizeHeading7: 8,    // h7-size (8/12 Bold)
  lineHeightHeading7: 12, // h7-line-height

  // Body text
  fontSize: 12,           // body-size (12/16 Regular) - base
  lineHeight: 16,         // body-line-height

  fontSizeLG: 14,         // body-large-size (14/20 Regular)
  lineHeightLG: 20,       // body-large-line-height

  fontSizeSM: 10,         // body-small-size (10/14 Regular)
  lineHeightSM: 14,       // body-small-line-height

  fontSizeXS: 8,          // body-ex-small-size (8/12 Regular)
  lineHeightXS: 12,       // body-ex-small-line-height
};

